<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const id = $props.id();
	const { data, lightboxId = id }: ContentBlockComponentProps<ContentType.Quotation> = $props();
</script>

<div class="full-width py-12 lg:!px-8 text-center lg:text-left">
	<blockquote class="max-w-2xl text-fstonyx text-lg italic leading-[1.15] tracking-[0.42px]">
		<q><Formatted text={data.quotation} /></q>
	</blockquote>

	<figure class="flex flex-col gap-4">
		<figcaption
			class="flex flex-col text-[1.4rem] leading-[1.15] tracking-[0.42px] italic text-fstgrey-500 mt-4 lg:mt-2"
		>
			<span class="quotation-author">
				<Formatted text={data.authorName} />,
			</span>
			<span><Formatted text={data.authorTitle} /></span>
		</figcaption>
	</figure>
</div>
